import React, { useState, useEffect } from "react";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import IconDesc from "../my-course/IconDesc";
import { bookIcon, geoMarkIcon, checkCircleIcon, awardIcon, rssIcon } from "../../../constants/icons";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import { useSelector } from "react-redux";

function CourseEventsHeader({eventTimeFull, course, className}) {
  const paths                               = useSelector((state) => state.user.paths);
  const [bceName, setBceName]               = useState('');
  const [bceSummary, setBceSummary]         = useState('');
  const [bceBannerImage, setBceBannerImage] = useState('');
  const [instructorName, setInstructorName] = useState('');
  const [bceEndDate, setBceEndDate]         = useState('');
  const [bceVenue, setBceVenue]             = useState('');
  const [isCertificateAvailable, setIsCertificateAvailable] = useState('0');
  const [bceScheduleType, setBceScheduleType] = useState('');

  useEffect(() => {
    setBceName(course.bce_name);
    setBceSummary(course.bce_summary);
    setBceBannerImage(paths.event_path + course.bce_banner);
    setInstructorName(course.bce_certificate_instructor_name);
    setBceEndDate(course.bce_end_date);
    setIsCertificateAvailable(course.bce_certificate_available);
    setBceScheduleType(course.bce_schedule_type);
    if(course.bce_delivered_type == 'venue'){
      setBceVenue(course.bce_venue +', '+ course.bce_venue_location);
    } else {
      if(course.bce_schedule_type == 'basic'){
        console.log('course.bce_schedule_type',course.bce_schedule_type);
        setBceVenue('Live Online');
      }
    }
  },[course]);

  // console.log('bce_name', course?.course);
  return (
    <div className={`${className || ""} course-inner-header course-event-inner-header`} style={{backgroundImage: `url(${bceBannerImage})`,backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}}>
      <Container>
        <Row className="align-items-center">
          <Col lg={8}>
            <div className="course-description">
              <h1>{bceName}</h1>
              <p className="mb-1">{bceSummary}</p>
              {
                isCertificateAvailable === '1' &&
                <div className="d-flex align-items-center gap-1 my-3">
                  <IconDesc
                    icon={awardIcon}
                    paraDesc="Certified"
                  />
                </div>
              }
              
              <div className="rating-wrapper d-block d-md-flex align-items-center gap-3 mb-3 mt-1">
                {
                  instructorName && <IconDesc
                  icon={bookIcon}
                  paraDesc="Instructed by"
                  linkDesc={instructorName}
                  link="#"
                  className="mb-1 mb-md-0"
                />
                }
                {
                  bceScheduleType == 'basic' && 
                  <IconDesc
                    icon={checkCircleIcon}
                    paraDesc={`Expiring on ${eventTimeFull}`}
                    className="mb-1 mb-md-0"
                  />
                }
                
                {
                  bceScheduleType == 'basic' && 
                  <IconDesc
                    icon={bceVenue == 'Live Online' ? rssIcon : geoMarkIcon}
                    paraDesc={bceVenue}
                    className="mb-1 mb-md-0"
                  />
                }
                
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CourseEventsHeader;
